import { gql } from "@grandvisionhq/graphql";
const storeGroupEntry = gql`
  fragment StoreGroupEntry on Store {
    globalStoreId
    code
    name
    streetName
    streetNumber
    additionalStreetInfo
    town
    province
    country
    slug
    rating {
      value
      count
    }
    postalCode
    storeEmailAddress
    email
    phone
    servicesNotAvailable
    appointmentsAvailable
    lat
    lon
    monOpenClose {
      open
      close
    }
    tueOpenClose {
      open
      close
    }
    wedOpenClose {
      open
      close
    }
    thuOpenClose {
      open
      close
    }
    friOpenClose {
      open
      close
    }
    satOpenClose {
      open
      close
    }
    sunOpenClose {
      open
      close
    }
    specialOpenClosingHours {
      openClosed
      dateOpenClosed
      openClosedTime {
        open
        close
      }
    }
    weekendOpen
    storenote
    storeDetailImage
    accessibility
    hearingAppointmentPossible
    wheelchairAccessible
    storeTypes
  }
`;
const GET_STORE_GROUP = gql`
  query GetStoreGroup($groupName: String!) {
    stores(groupName: $groupName) {
      ...StoreGroupEntry
    }
  }
  ${storeGroupEntry}
`;
export {
  GET_STORE_GROUP
};
//# sourceMappingURL=queries.js.map
